import {GESTION_OPERATIVA_CLEANURL_PAYMENT} from '../constants'

export function cleanUrlPayments(){
    return async dispatch => {
        dispatch({
            type: GESTION_OPERATIVA_CLEANURL_PAYMENT
        })
    }
}